import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import ApiManager from "../../api/ApiManager";
import Button from "../../components/Button/Button";
import OnboardingLayout from "../../layouts/OnboardingLayout/OnboardingLayout";
import Typography from "../../components/Typography/Typography";
import Input from "../../components/Input/Input";
import SingleCheckBox from "../../components/SingleCheckBox/SingleCheckBox";
import { ArrowLeft } from "lucide-react";
import { Toaster, toast } from "react-hot-toast";

const api = new ApiManager();

const RegisterForm = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .post("/register", {
        first_name: credentials.first_name,
        last_name: credentials.last_name,
        email: credentials.email,
        password: credentials.password,
      })
      .then((res) => {
        const projectId = res.data.project_id;
        document.cookie = `project_id=${projectId}; path=/`;

        navigate("/verify", { state: { userData: res.data } });
      })
      .catch((error) => {
        toast.error(error.response.data.Message);
      });
  };

  useEffect(() => {
    setIsFormComplete(
      Object.values(credentials).every((value) => value.trim() !== "")
    );
  }, [credentials]);

  return (
    <OnboardingLayout hasProgress={false}>
      <div className="pt-12 pb-14 md:mx-auto md:w-[40rem] w-auto px-4 flex flex-col gap-4 md:gap-9">
        <Button
          onClick={() => navigate(-1)}
          size="md"
          type="bw"
          icon={<ArrowLeft size="24" />}
        />
        <Typography
          family="serif"
          size="32"
          desktopSize="48"
          weight="sb"
          color="black"
        >
          Crea un Account
        </Typography>
        <Toaster />
        <form className="flex flex-col gap-[36px]" onSubmit={handleSubmit}>
          <div className="flex flex-col gap-4">
            <div className="flex flex-row gap-4">
              <Input
                title="Nome"
                name="first_name"
                value={credentials.first_name}
                onChange={handleChange}
              />
              <Input
                title="Cognome"
                name="last_name"
                value={credentials.last_name}
                onChange={handleChange}
              />
            </div>
            <Input
              title="Email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
            />
            <Input
              type="password"
              title="Password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="7+ caratteri"
            />
            {/* <Input
              type="password"
              title="Conferma Password"
              name="confirmPassword"
              value={credentials.confirmPassword}
              onChange={handleChange}
            /> */}
          </div>
          <SingleCheckBox
            checked={isTermsAccepted}
            setChecked={setIsTermsAccepted}
          >
            <Typography>
              Accetto i
              <span className="mx-1">
                <Typography color="accent" weight="md" underline={true}>
                  <Link to="/legal/terms">Termini di servizio</Link>
                </Typography>
              </span>
              e l'
              <span className="mx-1">
                <Typography color="accent" weight="md" underline={true}>
                  <Link to="/legal/terms">informativa sulla privacy</Link>
                </Typography>
              </span>
              di Athena
            </Typography>
          </SingleCheckBox>
          <Button
            text="Registrati"
            width="full"
            size={window.innerWidth >= 768 ? "lg" : "md"}
            type="color"
            disabled={!isFormComplete || !isTermsAccepted}
          />
        </form>
      </div>
    </OnboardingLayout>
  );
};

export default RegisterForm;
